// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__yt1Jg","selects":"Documents_selects__3awC1"};